<template>
    <dashboard-layout
        :email-label="emailLabel"
        :email-suffix="emailSuffix"
        :extra-login-data="extraLoginData"
    >
        <template slot="sidebar-menu">
            <sidebar-link
                index="1"
                name="Grilles tarifaires"
                i="ti-layers-alt"
                to="dashboard"
            >
            </sidebar-link>
            <sidebar-link
                index="2"
                name="Clients"
                i="el-icon-s-custom"
                to="client"
            >
            </sidebar-link>
            <sidebar-link
                index="3"
                name="Facturations"
                i="el-icon-tickets"
                to="facturation"
            >
            </sidebar-link>
            <sidebar-link
                v-if="$store.getters.useApiValo"
                index="3"
                name="Users"
                i="ti-user"
                to="user"
            >
            </sidebar-link>
        </template>
    </dashboard-layout>
</template>

<script>
import {DashboardLayout} from 'fundation-app-vuejs';
import { mapGetters } from 'vuex';

export default {
    name: 'App',
    components: {
        DashboardLayout,
    },
    created(){
        console.log('Here')
        console.log(this.$store.getters.userIsAtLeastAdmin);
    },
    computed: {
        ...mapGetters('fundation', [
            'loginImage',
            'getText',
            'useApiValo'
        ]),
        emailLabel () {
            return window.config.use_apivalo_auth === true ? 'NNi' : null;
        },
        emailSuffix () {
            return window.config.use_apivalo_auth === true ? window.config.email_suffix : null;
        },
        extraLoginData () {
            return window.config.use_apivalo_auth === true ? {user_type: 'SESAME'} : null;
        },
    }
};
</script>

<style lang="scss">
@import './main.scss';
html, body{
    margin: 0px;
    padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue